<template>
  <div class="message-header">
    <i class="r2-icon-hardware_keyboard_backspace_outlined margin-right-5 cursor-pointer" @click="handleClick"></i> {{pageTitle}}
  </div>
</template>
<style lang="less" type="text/less" scoped>
  .message-header{
    width: 100%;
    padding: 0 24px;
    height: 56px;
    line-height: 56px;
    margin: 0 auto;
    color: #fff;
    box-sizing: border-box;
    cursor: default;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
  }
</style>
<script>
export default {
  name: 'HeaderMessage',
  props: {
    pageTitle: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick (evt) {
      this.$emit('clickHandle', evt)
    }
  }
}
</script>
